/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SvgInfoAdminDto } from '../../models/svg-info-admin-dto';
import { SvgInfoAdminForm } from '../../models/svg-info-admin-form';

export interface UpdateSvgInfoAdmin$Params {

/**
 * svg id
 */
  id: number;
      body: SvgInfoAdminForm
}

export function updateSvgInfoAdmin(http: HttpClient, rootUrl: string, params: UpdateSvgInfoAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<SvgInfoAdminDto>> {
  const rb = new RequestBuilder(rootUrl, updateSvgInfoAdmin.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SvgInfoAdminDto>;
    })
  );
}

updateSvgInfoAdmin.PATH = '/svg-info-admin/{id}';
